import React from 'react'
import { Switch, Route, Redirect } from 'react-router'
import loadable from '@loadable/component'

import { LANGUAGES } from '../_i18n/languages'
// const Terms = loadable(() => import('../terms/Terms'))


const Home = loadable(() => import('../home/Home'))
const About = loadable(() => import('../about/About'))
const Terms = loadable(() => import('../terms/Terms'))
const Privacy = loadable(() => import('../privacy/Privacy'))
const NotFound = loadable(() => import('../notFound/NotFound'))
const JsonPretty = loadable(() => import('../jsonPretty/JsonPretty'))
const XmlPretty = loadable(() => import('../xmlPretty/XmlPretty'))
const CharacterCount = loadable(() => import('../counters/CharacterCount'))
const UuidGenerator = loadable(() => import('../uuid/UuidGenerator'))
const UuidFormatter = loadable(() => import('../uuid/UuidFormatter'))
const UuidValidator = loadable(() => import('../uuid/UuidValidator'))
const TextReplacer = loadable(() => import('../textReplacer/TextReplacer'))
const RandomName = loadable(() => import('../random/RandomName'))
const RandomNumber = loadable(() => import('../random/RandomNumber'))
const TallyCounter = loadable(() => import('../counters/TallyCounter'))
const MorseCodeTranslator = loadable(() => import('../morseCode/MorseCodeTranslator'))
const NamePickerWheel = loadable(() => import('../pickerWheel/NamePickerWheel'))
const Calculator = loadable(() => import('../calculator/Calculator'))
const QrCodeGenerator = loadable(() => import('../qrcode/QrCodeGenerator'))
const PasswordGenerator = loadable(() => import('../password/PasswordGenerator'))
const BinaryTranslator = loadable(() => import('../binaryTranslator/BinaryTranslator'))
const TimeCalculator = loadable(() => import('../calculator/TimeCalculator'))
const WingdingsTranslator = loadable(() => import('../wingdingsTranslator/WingdingsTranslator'))
const DuplicateRemover = loadable(() => import('../duplicateRemover/DuplicateRemover'))
const HtmlCssFormatter = loadable(() => import('../codePrettifier/HtmlCssFormatter'))
const CodeMinifier = loadable(() => import('../codeMinifier/CodeMinifier'))
const JsonToCsv = loadable(() => import('../jsonToCsv/JsonToCsv'))
const CsvToJson = loadable(() => import('../csvToJson/CsvToJson'))
const Lipsum = loadable(() => import('../lipsum/Lipsum'))
const Base64Converter = loadable(() => import('../base64/Base64Converter'))
const MarkdownToHtml = loadable(() => import('../markdownToHtml/MarkdownToHtml'))
const HtmlToMarkdown = loadable(() => import('../htmlToMarkdown/HtmlToMarkdown'))
const PasswordStrength = loadable(() => import('../password/PasswordStrength'))
const HashGenerator = loadable(() => import('../hashGenerator/HashGenerator'))
const ImageToWebp = loadable(() => import('../imageToWebp/ImageToWebp'))
const CompoundInterest = loadable(() => import('../compoundInterest/CompoundInterest'))
const ProfitMargin = loadable(() => import('../profitMargin/ProfitMargin'))
const FreelanceRate = loadable(() => import('../freelanceRate/FreelanceRate'))
const JwtDecoder = loadable(() => import('../jwtDecoder/JwtDecoder'))
const CronGenerator = loadable(() => import('../cronGenerator/CronGenerator'))
const SqlFormatter = loadable(() => import('../sqlFormatter/SqlFormatter'))
const RegexTester = loadable(() => import('../regexTester/RegexTester'))
const UtmBuilder = loadable(() => import('../utmBuilder/UtmBuilder'))
const CpmCalculator = loadable(() => import('../cpmCalculator/CpmCalculator'))
const OpenGraphPreview = loadable(() => import('../openGraphPreview/OpenGraphPreview'))
const DiffChecker = loadable(() => import('../diffChecker/DiffChecker'))
const ExifRemover = loadable(() => import('../exifRemover/ExifRemover'))
const DebtPayoff = loadable(() => import('../debtPayoff/DebtPayoff'))
const MortgageCalculator = loadable(() => import('../mortgageCalculator/MortgageCalculator'))
const InsuranceCalculator = loadable(() => import('../insuranceCalculator/InsuranceCalculator'))
const UnitConverter = loadable(() => import('../unitConverter/UnitConverter'))
const TemperatureConverter = loadable(() => import('../temperatureConverter/TemperatureConverter'))


const MultiLanguageRoute = (props) => {
    //const defaultLanguage = LANGUAGES.en.urlLang
    let hasLang = props.computedMatch.params.lang
    hasLang = hasLang ? hasLang : 'en'
    const is404Page = props.location.pathname.split('/')[3]
    //const isBasePathWithoutLang = props.location.pathname === "/"
    const currentLanguage = LANGUAGES[hasLang]

    //if(isBasePathWithoutLang)  return <Redirect to={`/${defaultLanguage}`} />
    //if(!hasLang && !is404Page) return <Redirect to={`/${defaultLanguage}`} />
    if (!currentLanguage || is404Page) return <Route component={NotFound} />

    return <Route {...props} />
}

const RedirectRoute = (props) => {
    //const defaultLanguage = LANGUAGES.en.urlLang
    let hasLang = props.computedMatch.params.lang
    hasLang = hasLang ? hasLang : 'en'
    const is404Page = props.location.pathname.split('/')[3]
    const currentLanguage = LANGUAGES[hasLang]
    if (!currentLanguage || is404Page) return <Route component={NotFound} />
    return props.redirectUrl ? <Redirect to={props.redirectUrl} /> : <Route component={NotFound} />
}

const routes = props => (
    <React.Fragment>
        <Switch>
            <Route exact path='/' component={Home} />
            <MultiLanguageRoute path='/about/:lang?' component={About} />
            <MultiLanguageRoute path='/terms/:lang?' component={Terms} />
            <MultiLanguageRoute path='/privacy/:lang?' component={Privacy} />
            <MultiLanguageRoute path='/wingdings-translator/:lang?' component={WingdingsTranslator} />
            <MultiLanguageRoute path='/binary-code-translator/:lang?' component={BinaryTranslator} />
            <MultiLanguageRoute path='/json-pretty-print/:lang?' component={JsonPretty} />
            <MultiLanguageRoute path='/xml-pretty-print/:lang?' component={XmlPretty} />
            <Route path='/case-converter' render={(props) => <Home {...props} custom={{
                'title': 'Case Converter - TextCaseConvert',
                'description': 'Case Converter is a free online tool to converts any text to Title Case, UPPERCASE, lowercase, camelCase, PascalCase, aLtErNaTiNg, Sentence case and more'
            }} />} />
            <Route path='/convertcase' render={(props) => <Home {...props} custom={{
                'title': 'Convert Case - TextCaseConvert',
                'description': 'Convert Case is a free online tool to converts any text to Title Case, UPPERCASE, lowercase, camelCase, PascalCase, aLtErNaTiNg, Sentence case and more'
            }} />} />
            <Route path='/caps-convert' render={(props) => <Home {...props} custom={{
                'title': 'Caps Convert - TextCaseConvert',
                'description': 'Caps Convert is a free online tool to convert text to UPPERCASE. See more options of conversions for lowercase, camelCase, PascalCase, aLtErNaTiNg, Sentence case and more'
            }} />} />
            <Route path='/case-changer' render={(props) => <Home {...props} custom={{
                'title': 'Case Changer - TextCaseConvert',
                'description': 'Case Changer is a free online tool to change any text to Title Case, UPPERCASE, lowercase, camelCase, PascalCase, aLtErNaTiNg, Sentence case and more'
            }} />} />
            <Route path='/convert-text' render={(props) => <Home {...props} custom={{
                'title': 'Convert Text - TextCaseConvert',
                'description': 'Convert Text is a free online tool to convert any text to Title Case, UPPERCASE, lowercase, camelCase, PascalCase, aLtErNaTiNg, Sentence case and more'
            }} />} />
            <Route path='/uppercase-to-lowercase' render={(props) => <Home {...props} custom={{
                'title': 'UpperCase to LowerCase - TextCaseConvert',
                'description': 'UpperCase to LowerCase is a free online tool to convert text in uppercase to lowercase. See more options of conversions for Title Case, camelCase, PascalCase, aLtErNaTiNg, Sentence case and more'
            }} />} />
            <Route path='/convert-caps-to-lowercase' render={(props) => <Home {...props} custom={{
                'title': 'Convert Caps to LowerCase - TextCaseConvert',
                'description': 'Convert Caps to LowerCase is a free online tool to convert text in caps to lowercase. See more options of conversions for Title Case, camelCase, PascalCase, aLtErNaTiNg, Sentence case and more'
            }} />} />
            <Route path='/lowercase-into-uppercase' render={(props) => <Home {...props} custom={{
                'title': 'LowerCase into UpperCase - TextCaseConvert',
                'description': 'LowerCase into UpperCase is a free online tool to convert text in lowercase to uppercase. See more options of conversions for Title Case, camelCase, PascalCase, aLtErNaTiNg, Sentence case and more'
            }} />} />
            <Route path='/capitalize-text' render={(props) => <Home {...props} custom={{
                'title': 'Capitalize Text - TextCaseConvert',
                'description': 'Capitalize Text is a free online tool to convert any text to capitalized text. See more options of conversions for Title Case, camelCase, PascalCase, aLtErNaTiNg, Sentence case and more'
            }} />} />
            <Route path='/text-convert-uppercase' render={(props) => <Home {...props} custom={{
                'title': 'Text Convert Uppercase - TextCaseConvert',
                'description': 'Text Convert Uppercase is a free online tool to convert any text to uppercase text. See more options of conversions for Title Case, camelCase, PascalCase, aLtErNaTiNg, Sentence case and more'
            }} />} />
            <Route path='/kebab-case' render={(props) => <Home {...props} custom={{
                'title': 'Kebab Case Converter - TextCaseConvert',
                'description': 'Kebab Case Converter is a free online tool to convert any text to Kebab Case text. See more options of conversions for Title Case, camelCase, PascalCase, aLtErNaTiNg, Sentence case and more'
            }} />} />
            <Route path='/wheel-of-names/:lang?' component={(props) => {
                let redirectUrl = "/wheel-decide" + (props.match.params.lang ? "/" + props.match.params.lang : "");
                if (props.staticContext) { // to SSR
                    props.staticContext.status = 301;
                    props.staticContext.redirectUrl = redirectUrl;
                }
                return (<Redirect to={redirectUrl} />)
            }} />
            <Route path='/calculadora-de-horas/pt' render={(props) => <TimeCalculator {...props} custom={{
                'title': 'Calculadora de Horas (adição ou subtração) - Duração',
                'description': 'Esta é uma calculadora de horas que permite adicionar ou subtrair horas, minutos e segundos. Você pode realizar cálculos de tempo facilmente.'
            }} />} />
            <Route path='/horas-trabalhadas/pt' render={(props) => <TimeCalculator {...props} custom={{
                'title': 'Calculadora de Horas Trabalhadas - Grátis Fácil de Usar',
                'description': 'Esta é uma calculadora de horas trabalhadas que permite adicionar ou subtrair horas, minutos e segundos. Você pode realizar cálculos de tempo facilmente.'
            }} />} />
            <RedirectRoute path='/wheel-of-names/:lang?' redirectUrl="/wheel-decide" {...props} />
            <MultiLanguageRoute path='/replace-text/:lang?' component={TextReplacer} />
            <MultiLanguageRoute path='/uuid-generator/:lang?' component={UuidGenerator} />
            <MultiLanguageRoute path='/uuid-formatter/:lang?' component={UuidFormatter} />
            <MultiLanguageRoute path='/uuid-validator/:lang?' component={UuidValidator} />
            <MultiLanguageRoute path='/character-count/:lang?' component={CharacterCount} />
            <MultiLanguageRoute path='/random-name/:lang?' component={RandomName} />
            <MultiLanguageRoute path='/random-number/:lang?' component={RandomNumber} />
            <MultiLanguageRoute path='/tally-counter/:lang?' component={TallyCounter} />
            <MultiLanguageRoute path='/morse-code/:lang?' component={MorseCodeTranslator} />
            <MultiLanguageRoute path='/wheel-decide/:lang?' component={NamePickerWheel} />
            <MultiLanguageRoute path='/calculator/:lang?' component={Calculator} />
            <MultiLanguageRoute path='/time-calculator/:lang?' component={TimeCalculator} />
            <MultiLanguageRoute path='/qr-code-generator/:lang?' component={QrCodeGenerator} />
            <MultiLanguageRoute path='/password-generator/:lang?' component={PasswordGenerator} />
            <MultiLanguageRoute path='/remove-duplicate-lines/:lang?' component={DuplicateRemover} />
            <MultiLanguageRoute path='/html-formatter/:lang?' render={(props) => <HtmlCssFormatter {...props} mode="html" />} />
            <MultiLanguageRoute path='/css-beautifier/:lang?' render={(props) => <HtmlCssFormatter {...props} mode="css" />} />
            <MultiLanguageRoute path='/code-minifier/:lang?' component={CodeMinifier} />
            <MultiLanguageRoute path='/css-minifier/:lang?' render={(props) => <CodeMinifier {...props} defaultMode="css" />} />
            <MultiLanguageRoute path='/javascript-minifier/:lang?' render={(props) => <CodeMinifier {...props} defaultMode="js" />} />
            <MultiLanguageRoute path='/json-to-csv/:lang?' component={JsonToCsv} />
            <MultiLanguageRoute path='/csv-to-json/:lang?' component={CsvToJson} />
            <MultiLanguageRoute path='/lorem-ipsum/:lang?' component={Lipsum} />
            <MultiLanguageRoute path='/base64-converter/:lang?' component={Base64Converter} />
            <MultiLanguageRoute path='/markdown-to-html/:lang?' component={MarkdownToHtml} />
            <MultiLanguageRoute path='/html-to-markdown/:lang?' component={HtmlToMarkdown} />
            <MultiLanguageRoute path='/password-strength-checker/:lang?' component={PasswordStrength} />
            <MultiLanguageRoute path='/hash-generator/:lang?' component={HashGenerator} />
            <MultiLanguageRoute path='/image-to-webp/:lang?' component={ImageToWebp} />
            <Route path='/png-to-webp' render={(props) => <ImageToWebp {...props} custom={{
                'title': 'PNG to WebP Converter Online - Free & Fast - TextCaseConvert',
                'description': 'Convert PNG images to WebP format online for free. Compress and optimize your PNG photos with instant client-side processing.'
            }} />} />
            <Route path='/jpg-to-webp' render={(props) => <ImageToWebp {...props} custom={{
                'title': 'JPG to WebP Converter Online - Free & Fast - TextCaseConvert',
                'description': 'Convert JPG/JPEG images to modern WebP format online for free. Boost page speeds with optimized WebP compression.'
            }} />} />
            <MultiLanguageRoute path='/compound-interest-calculator/:lang?' component={CompoundInterest} />
            <MultiLanguageRoute path='/profit-margin-calculator/:lang?' component={ProfitMargin} />
            <MultiLanguageRoute path='/freelance-rate-calculator/:lang?' component={FreelanceRate} />
            <MultiLanguageRoute path='/jwt-decoder/:lang?' component={JwtDecoder} />
            <MultiLanguageRoute path='/cron-expression-generator/:lang?' component={CronGenerator} />
            <MultiLanguageRoute path='/sql-formatter/:lang?' component={SqlFormatter} />
            <MultiLanguageRoute path='/regex-tester/:lang?' component={RegexTester} />
            <MultiLanguageRoute path='/utm-builder/:lang?' component={UtmBuilder} />
            <MultiLanguageRoute path='/cpm-calculator/:lang?' component={CpmCalculator} />
            <MultiLanguageRoute path='/open-graph-preview/:lang?' component={OpenGraphPreview} />
            <MultiLanguageRoute path='/diff-checker/:lang?' component={DiffChecker} />
            <MultiLanguageRoute path='/exif-remover/:lang?' component={ExifRemover} />
            <MultiLanguageRoute path='/debt-payoff-calculator/:lang?' component={DebtPayoff} />
            <MultiLanguageRoute path='/mortgage-calculator/:lang?' component={MortgageCalculator} />
            <MultiLanguageRoute path='/car-insurance-calculator/:lang?' render={(props) => <InsuranceCalculator {...props} initialTab="car" />} />
            <MultiLanguageRoute path='/insurance-calculator/:lang?' render={(props) => <InsuranceCalculator {...props} initialTab="car" />} />
            <MultiLanguageRoute path='/life-insurance-calculator/:lang?' render={(props) => <InsuranceCalculator {...props} initialTab="life" />} />
            <MultiLanguageRoute path='/unit-converter/:lang?' component={UnitConverter} />
            <MultiLanguageRoute path='/inches-to-cm/:lang?' component={UnitConverter} />
            <MultiLanguageRoute path='/cm-to-inches/:lang?' component={UnitConverter} />
            <MultiLanguageRoute path='/lbs-to-kg/:lang?' component={UnitConverter} />
            <MultiLanguageRoute path='/kg-to-lbs/:lang?' component={UnitConverter} />
            <MultiLanguageRoute path='/miles-to-km/:lang?' component={UnitConverter} />
            <MultiLanguageRoute path='/km-to-miles/:lang?' component={UnitConverter} />
            <MultiLanguageRoute path='/temperature-converter/:lang?' component={TemperatureConverter} />
            <MultiLanguageRoute path='/fahrenheit-to-celsius/:lang?' component={TemperatureConverter} />
            <MultiLanguageRoute path='/celsius-to-fahrenheit/:lang?' component={TemperatureConverter} />
            <MultiLanguageRoute path='/celsius-to-kelvin/:lang?' component={TemperatureConverter} />
            <MultiLanguageRoute path='/:lang' component={Home} />
            <Route component={NotFound} />
        </Switch>
    </React.Fragment>
)

export default routes